<template>
  <v-card>
    <v-card-title class="bgcolor-9 modal">
      <h1 class="titleModal">{{literal["CREDITOS"]}}</h1>
      <v-spacer></v-spacer>
      <i @click="setModalCredits(false)" class="icon-close"></i>
    </v-card-title>

    <!--Creditos del libromedio actual-->
    <v-card-text v-html="$store.state.ebook[this.$store.state.indexLM].creditos">
    </v-card-text>
  </v-card>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "ModalCredits",
  props:['literal'],
  methods:{
    ...mapMutations(["setModalCredits"]) 
  }
};
</script>